import React from 'react';
import ComingSoon from '../components/ComingSoon';

export default function StrategyLab() {
  return (
    <div className="pt-2">
      <ComingSoon
        eyebrow="FLOWQUANT PREMIUM"
        title="Strategy Lab"
        description="Design, test, and refine trading strategies with customizable rule sets, scenario thinking, and structured performance tracking built for serious traders."
      />
    </div>
  );
}